<template>
    <ion-grid>
        <ion-row class="ion-justify-content-center">
            <ion-col
                v-for="(option, index) in question.options"
                size="6"
                size-sm="3"
                :key="index"
            >
                <ion-card
                    button
                    @click="
                        $emit('done', {
                            value: option.value,
                            id: question.id,
                        })
                    "
                >
                    <ion-card-content class="ion-text-center">
                        <img :src="getImage(option)" />
                    </ion-card-content>
                </ion-card>
            </ion-col>
        </ion-row>
    </ion-grid>
</template>

<script>
import { IonGrid, IonRow, IonCol, IonCard, IonCardContent } from "@ionic/vue";

export default {
    components: {
        IonGrid,
        IonRow,
        IonCol,
        IonCard,
        IonCardContent,
    },
    props: {
        question: {
            required: true,
            type: Object,
        },
    },
    methods: {
        getImage(option) {
            let result = "";
            if (option.image) {
                result = require("@lib/assets/img/buttons/" + option.image);
            }
            return result;
        },
    },
};
</script>

<style scoped></style>
